import { PcPlayerReleaseApp, pcPlayerDownloadUrl } from "@/constants";

/**
 * 신 PC Player(3.x) 최신 설치본 다운로드 URL.
 *
 * ★URL 을 **리터럴로 적지 않는다** — 같은 목적지가 두 표기로 존재하면 한쪽만 고쳐진다
 * (`__tests__/v2-components/legacy-games-search-links.test.ts` 가 같은 형태를 잠근다).
 * 정본은 `constants.ts` 의 `PcPlayerReleaseApp` + `pcPlayerDownloadUrl` 이다.
 */
export const usePCPLatestRelease = () => {
  return {
    mac: pcPlayerDownloadUrl(PcPlayerReleaseApp.mac),
    win: pcPlayerDownloadUrl(PcPlayerReleaseApp.win),
  };
};
